import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectRatio1To112(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMediaObjectRatio1To112"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 2h-2a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5m-2-1A1.5 1.5 0 0 0 0 2.5v7A1.5 1.5 0 0 0 1.5 11h2A1.5 1.5 0 0 0 5 9.5v-7A1.5 1.5 0 0 0 3.5 1zM7 2.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5M7.5 6a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zM7 4.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5M7.5 8a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectRatio1To112);
